import { render, staticRenderFns } from "./CoaList.vue?vue&type=template&id=24369eb8"
import script from "./CoaList.vue?vue&type=script&lang=js"
export * from "./CoaList.vue?vue&type=script&lang=js"
import style0 from "./CoaList.vue?vue&type=style&index=0&id=24369eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports